import { MissingTranslationHandler, MissingTranslationHandlerParams } from '@ngx-translate/core';

/**
 * Called only when a key is missing in both the current and the fallback language. Reports each key once and renders
 * the key itself, so the gap is visible instead of leaving an empty label or button.
 */
export class ReportingMissingTranslationHandler implements MissingTranslationHandler {
  private readonly reportedKeys = new Set<string>();

  handle({ key }: MissingTranslationHandlerParams): string {
    if (!this.reportedKeys.has(key)) {
      this.reportedKeys.add(key);
      console.error(`[i18n] Missing translation "${key}"`);
    }
    return key;
  }
}
